import { motion } from "framer-motion";
import ShareButtons from "../../../../utility/ShareButtons";

import useServiceData from "../../../../utility/useServiceData";
import FAQAccordion from "../../../../utility/FAQAccordion";
import WhyUs from "../../../../utility/serviceTemplateutility/WhyUs";
import CardDesign from "../../../../utility/serviceTemplateutility/CardDesign";
import ListDesign from "../../../../utility/serviceTemplateutility/ListDesign";

import QuickNavigation from "../../../../utility/serviceTemplateutility/QuickNavigation";
import MultiStepForm from "../../../../utility/serviceTemplateutility/MultiStepForm";
import OurTeam from "../../../homepage/OurTeam";
import Testimonials from "../../../homepage/Testimonials";
import { useGlobalData } from "../../../../contextApi/globalContextData";
import { useLanguage } from "../../../../contextApi/languageContext";
import { useCart } from "../../../../contextApi/cartContext";
import { beardlaser } from "../../../../text-files/laser/beardlaser.ts";
import BeforeAfterCarousel from "../../../../utility/serviceTemplateutility/BeforeAfterCarousel.jsx";
export default function BeardLaser() {
  const serviceUrl = window.location.href;
  const data = useServiceData("Beard Laser");
  const imageUrl = data?.image_url;

  const { language } = useLanguage();
  const { addToCart } = useCart();
  const { sectionsData } = useGlobalData();
  const content = beardlaser[language];
  const shared = beardlaser.shared;
  const faqData = [
    { heading: "Frequently Asked Questions" },
    {
      question: "What are the number of treatments required?",
      answer:
        "Generally 4-6 most often, depending on hair, skin color and your natural cycle. The point is, it will work on active follicles that allow multiple treatments to affect them entirely.",
    },
    {
      question: "Does the laser beard treatment hurt?",
      answer:
        "Not. It is almost pain-free, but most clients only feel a tingling sensation. Our cooling gel ensures maximum comfort.",
    },
    {
      question: "Is laser hair removal for men safe?",
      answer:
        "Yes, laser hair removal for men is a safe and effective procedure when performed by trained professionals using advanced technology.",
    },
    {
      question: "Can I shave between the sessions?",
      answer:
        "Yes, shaving is allowed between the sessions, but waxing and plucking should be avoided as they disrupt the hair follicle.",
    },
    {
      question: "Is laser beard shaping permanent?",
      answer:
        "The results are long-term, but touch-ups may be required to achieve your ideal look.",
    },
    {
      question: "Can I shave between the sessions?",
      answer:
        "Yes, shaving is allowed between the sessions, but waxing and plucking should be avoided as they disrupt the hair follicle.",
    },
  ];

  const aftercareTips = [
    { heading: "Aftercare Tips" },
    {
      para: "Following a laser beard treatment, some mild redness or tingling may be present but will usually subside in hours. To enhance your outcome",
    },
    {
      title: "Avoid Sun Exposure",
      description:
        "Use sunscreen and avoid direct sunlight for at least one week.",
      icon: "fa-solid fa-sun",
    },
    {
      title: "Gentle Skin Care",
      description:
        "Use mild cleaners and moisturizers; stay away from harsh products.",
      icon: "fa-solid fa-hand-holding-droplet",
    },
    {
      title: "Cold Compresses",
      description: "Cold compresses can help ease the treated area if needed.",
      icon: "fa-solid fa-snowflake",
    },
    {
      title: "Hydration",
      description: "Keep the area moist to help heal.",
      icon: "fa-solid fa-glass-water-droplet",
    },
  ];

  const beforeAfterImages = [
    "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/12/1-3.jpg",
    "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/12/5-1.jpg",
    "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/12/3-1.jpg",
    "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/12/2-2.jpg",
    "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/12/4-1.jpg",
  ];

  const sideEffects = [
    { text: "Temporary redness or mild swelling in the treated area." },
    { text: "Skin sensitivity for a few hours post-treatment." },
    {
      text: "Temporary lightening or darkening of the skin (pigmentation changes).",
    },
    { text: "Mild dryness or flakiness, manageable with moisturizers." },
    {
      text: "Rare risks of burns, scarring, or blistering if not performed properly.",
    },
  ];

  const laserBeardBenefits = [
    { text: "Perfectly defined beard lines." },
    { text: "No need for daily shaving." },
    { text: "Long-lasting results." },
    { text: "Smooth, bump-free skin." },
    { text: "Customized to your style." },
    { text: "Safe and non-invasive." },
    { text: "Boosts confidence." },
    { text: "Gets rid of ingrown hairs." },
  ];

  const laserHairRemovalAreasMen = [
    { text: "Face and Neck" },
    { text: "Chest and Back" },
    { text: "Arms and Underarms" },
    { text: "Legs" },
    { text: "Shoulders" },
    { text: "Private Areas" },
  ];

  const laserBeardProcedure = [
    { heading: "Laser Beard Shaping & Removal Procedure" },
    {
      para: "Laser beard shaping in Dubai includes a range of steps that needs to be performed correctly. Here we have mentioned them",
    },
    {
      title: "Consultation",
      description:
        "Our expert dermatologist will assess your skin type, hair growth pattern, and desired beard style.",
      icon: "fa-solid fa-user-doctor",
    },
    {
      title: "Preparation",
      description:
        "The area is cleaned, and after this a cooling gel is applied.",
      icon: "fa-solid fa-spa",
    },
    {
      title: "Laser Procedure",
      description:
        "A laser device is used to emit controlled light pulses, targeting hair follicles correctly.",
      icon: "fa-solid fa-lightbulb",
    },
    {
      title: "Customization",
      description:
        "Laser settings are adjusted based on your hair thickness, skin tone, and the results.",
      icon: "fa-solid fa-sliders",
    },
    {
      title: "Procedure is Performed",
      description:
        "The procedure is quick and efficient and takes around 20–40 minutes.",
      icon: "fa-solid fa-clock",
    },
  ];

  return (
    <>
      <title>Laser Hair Removal Beard | Laser Beard Shaping</title>
      <meta
        name="description"
        content="Achieve sharp, defined beard lines with Laser Beard Shaping in Dubai. Long-lasting results with Laser Hair Removal Beard treatments at Elite Body Home."
      />
      <meta
        name="robots"
        content="follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
      />
      <link
        rel="canonical"
        href="https://elitebodyhome.com/services/laser-hair-removal-beard/"
      />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="article" />
      <meta
        property="og:title"
        content="Laser Hair Removal Beard | Laser Beard Shaping"
      />
      <meta
        property="og:description"
        content="Achieve sharp, defined beard lines with Laser Beard Shaping in Dubai. Long-lasting results with Laser Hair Removal Beard treatments at Elite Body Home."
      />
      <meta
        property="og:url"
        content="https://elitebodyhome.com/laser-hair-removal-beard/"
      />
      <meta property="og:site_name" content="elitebodyhome.com" />
      <meta property="og:updated_time" content="2025-01-03T17:00:38+00:00" />
      <meta
        property="og:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/12/Beard-Feature-Image.jpg"
      />
      <meta
        property="og:image:secure_url"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/12/Beard-Feature-Image.jpg"
      />
      <meta property="og:image:width" content="1254" />
      <meta property="og:image:height" content="700" />
      <meta property="og:image:alt" content="Laser Hair Removal Beard" />
      <meta property="og:image:type" content="image/jpeg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Laser Hair Removal Beard | Laser Beard Shaping"
      />
      <meta
        name="twitter:description"
        content="Achieve sharp, defined beard lines with Laser Beard Shaping in Dubai. Long-lasting results with Laser Hair Removal Beard treatments at Elite Body Home."
      />
      <meta
        name="twitter:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/12/Beard-Feature-Image.jpg"
      />
      <div
        className="min-vh-100 font-sans text-dark  mb-5 mx-3"
        dir={language === "ar" ? "rtl" : "ltr"}
      >
        {/* Hero Image Section */}
        {shared.images.main && (
          <section className="overflow-hidden ">
            <div className="position-relative mb-3">
              <img
                src={shared.images.main}
                alt="male energy Dubai"
                className="img-fluid w-100 rounded mt-2 "
                style={{
                  height: "500px",
                  objectFit: "cover",
                  objectPosition: "top",
                  border: "2px solid #c69933",
                  borderRadius: "100px",
                }}
              />
            </div>
          </section>
        )}

        <div className="d-flex gap-4  w-100 ">
          <div
            className=" rounded-4 p-1 bg-white flex-grow-1 "
            style={{
              width: "65%",
              border: "2px solid #c69933",
            }}
          >
            {/* Main Content Column */}

            {/* Breadcrumbs */}
            <nav aria-label="breadcrumb" className="p-2">
              <ol className="breadcrumb">
                {content.breadcrumbs.map((item, index) => (
                  <li
                    key={index}
                    className={`breadcrumb-item ${
                      index === content.breadcrumbs.length - 1 ? "active" : ""
                    }`}
                    aria-current={
                      index === content.breadcrumbs.length - 1
                        ? "page"
                        : undefined
                    }
                  >
                    {index === content.breadcrumbs.length - 1 ? (
                      item
                    ) : (
                      <a href={index === 0 ? "/home" : "#"}>{item}</a>
                    )}
                  </li>
                ))}
              </ol>
            </nav>

            {/* Title Section */}
            <div className="text-center my-2">
              <motion.h1
                className="display-4 fw-bold"
                style={{ color: "#c69933" }}
              >
                {content.hero.title}
              </motion.h1>

              {content.hero.subtitle && (
                <motion.h2 className="fw-semibold mt-3">
                  {content.hero.subtitle}
                </motion.h2>
              )}

              {content.hero.description && (
                <motion.p className="lead mt-3">
                  {content.hero.description}
                </motion.p>
              )}
            </div>

            <QuickNavigation />

            {/* How It Works Section */}
            {content.howItWorks.title && (
              <motion.section className="my-5">
                <h2 className="h2 fw-bold mb-4 text-center">
                  {content.howItWorks.title}
                </h2>
                {content.howItWorks.description && (
                  <p className="text-muted text-center">
                    {content.howItWorks.description}
                  </p>
                )}
              </motion.section>
            )}

            {/* Introduction Image */}
            {shared.images.introductionImage && (
              <motion.div className="my-5">
                <div className="text-center">
                  <img
                    src={shared.images.introductionImage}
                    alt="fat freezing treatment dubai"
                    className="img-fluid rounded shadow"
                    style={{ maxHeight: "500px" }}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </motion.div>
            )}

            {/* Process Section */}
            <section id="process" className="my-5">
              <CardDesign carditems={content.procedureSteps} />
            </section>

            {/* Benefits Section */}
            <section id="benefits" className="my-5">
              <ListDesign listitems={content.benefits} />
            </section>

            <section id="process" className="my-5">
              <ListDesign listitems={content.sideEffects} />
            </section>

            {/* Eligibility Section */}
            <section id="eligibility" className="my-5">
              <CardDesign listitems={content.sideEffects} />
            </section>

            {/* Preparation Section */}
            <section id="preparations" className="my-5">
              <ListDesign listitems={content.eligibility} />
            </section>

            {/* Results Section */}
            <section id="results" className="my-5">
              <ListDesign listitems={content.results} />
            </section>

            {/* Before & After Section */}
            {shared.images.beforeAfter &&
              shared.images.beforeAfter.length > 0 && (
                <motion.section
                  className="my-5"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                >
                  <BeforeAfterCarousel
                    language={language}
                    images={shared.images.beforeAfter}
                  />
                </motion.section>
              )}
            {/* Aftercare Section */}
            <section className="my-5">
              <ListDesign listitems={content.aftercareTips} />
            </section>

            {/* Product Card */}
            {shared.images.main && (
              <motion.div
                className="my-5"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
              >
                <div
                  className="card border-0 shadow-lg rounded-4 overflow-hidden mx-auto"
                  style={{ maxWidth: "420px" }}
                >
                  <img
                    src={shared.images.main}
                    alt={content.meta.title}
                    className="card-img-top"
                    style={{ height: "280px", objectFit: "cover" }}
                  />
                  <div className="card-body text-center px-4 py-4">
                    <h5 className="card-title fw-bold text-uppercase text-dark mb-2">
                      {content.meta.title}
                    </h5>
                    <p className="card-text text-muted small">
                      {content.meta.description}
                    </p>
                    {/* <h6
                        className="text-success fw-bold mt-3"
                        style={{ fontSize: "1.1rem" }}
                      >
                        {language === "en" ? "Price" : "السعر"}: AED{" "}
                        {shared.product.price}
                      </h6> */}
                    <button
                      className="btn rounded-pill px-4 py-2 mt-3 text-white fw-bold"
                      style={{
                        background: "#c69933",
                        border: "2px solid #c69933",
                      }}
                      onClick={() =>
                        addToCart({
                          ...shared.product,
                          image: shared.images.main,
                        })
                      }
                    >
                      {language === "en" ? "Add to Cart" : "أضف إلى السلة"}
                    </button>
                  </div>
                </div>
              </motion.div>
            )}
            <WhyUs language={language} />
            <OurTeam data={sectionsData["Professional"]} />
            <Testimonials
              data={sectionsData["Success Stories"]}
              language={language}
            />
            <FAQAccordion faqData={content.faqData} />
            <ShareButtons url={serviceUrl} />
          </div>
          <MultiStepForm />
        </div>
      </div>
    </>
  );
}
